import { FC } from 'react'
import { connect } from 'react-redux'
import { ParticipationPageComponent } from './ParticipationPageComponent'
import { State } from '../core/reducers'

interface Props {
  // 如果需要从Redux状态映射props，可以在这里定义
}

const mapStateToProps = (state: State) => ({
  // 映射需要的状态
})

const mapDispatchToProps = {
  // 映射需要的actions
}

export const ParticipationPageContainer: FC<Props> = connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipationPageComponent)

export default ParticipationPageContainer